import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Modal,
} from "react-bootstrap";
import uniq from "lodash/uniq";
import compact from "lodash/compact";
import "../forms.css";
import styles from "./CollaboratorForm.styles";
import messages from "./CollaboratorForm.messages";
import GradientButton from "../../input/GradientButton";

import type { InviteCollaboratorObje } from "../../../redux/tasks/types";

type Props = {
  addCollaborator: (email: string, projectId: Int) => void,
  onDidAddCollaborator: () => void,
  onModalClose: () => void,
  projectId: Int,
};

type State = {
  email: string,
  showInvalidEmail: boolean,
};

export default class CollaboratorForm extends Component {
  props: Props;

  state: State = {
    email: "",
    showInvalidEmail: false,
  };

  addCollaboratorPromise: ?Promise<void>;

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handleAddCollaborator = (event) => {
    event.preventDefault();
    this.addCollaboratorPromise = Promise.resolve(this.addCollaborator());
  };

  async addCollaborator() {
    const task = await this.props.addCollaborator(
      this.state.email.toLowerCase(),
      this.props.projectId
    );
    if (task) {
      this.props.onDidAddCollaborator();
    } else {
      this.setState({ showInvalidEmail: true });
    }
  }

  renderInvalidEmail = () => {
    return (
      <ControlLabel style={styles.errorLabel}>
        {messages.invalidEmail}
      </ControlLabel>
    );
  };

  render() {
    return (
      <div>
        <form onSubmit={this.handleAddCollaborator}>
          <Modal.Body>
            <Row>
              <Col md={12}>
                <FormGroup>
                  {this.state.showInvalidEmail
                    ? this.renderInvalidEmail()
                    : null}
                  <ControlLabel>{messages.email}</ControlLabel>
                  <FormControl
                    type="text"
                    name={messages.email}
                    placeholder={messages.email}
                    onChange={this.handleEmailChange}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <GradientButton
              gradient="0/1"
              handleClick={this.props.onModalClose}
              title="Cancel"
            />
            <button type="submit" style={{ padding: 0, border: 'none' }}>
              <GradientButton gradient="1/1" title={messages.submit} />
            </button>
          </Modal.Footer>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/collaborator-form/CollaboratorForm.js